export enum ReceiptKitchenPrinterFontSize {
    BIG = 'big',
    SMALL = 'small'
}
